import { keycloakConfig } from "@env/keycloak.config.int";

export const environment = {
  production: true,
  keycloakConfig: keycloakConfig,
  googleApiKey: 'AIzaSyDrWaY4-JdFri7XcHU1Gt3QgRb9Z-y2N1E',
  websiteUrl: 'https://dev.clinitrix.ch',
  domain: 'dev.clinitrix.ch',
};
